import { Component, HostListener, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { AccountService } from '../../service/account.service';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'app-navbar',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    AvatarComponent
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  isMenuOpen = false;

  constructor(private router: Router) {}

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  navigate(path: string) {
    if (path.startsWith('http')) {
      window.open(path, '_blank');
    } else {
      this.router.navigate([path]);
    }
    this.isMenuOpen = false;
  } 

  logout() {
    this.accountService.logout().subscribe((data: any) => {
      if (data.code == 200) {
        this.router.navigate(['/']);
      }
    });
  }

  accountService = inject(AccountService);

  get isAdmin() {
    return this.accountService.account.value?.staff;
  }

  collapsed = false;
  oldScrollY = 0;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    this.collapsed = window.scrollY > this.oldScrollY;
    this.oldScrollY = window.scrollY;
  }

  skipToMainContent() {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
      // Focus the main content area to establish proper tab navigation flow
      mainContent.focus();
    }
  }
}
